import * as React from "react";
import {
  Box,
  Typography,
  Modal,
  Paper,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";

export default function CNDATA({ open, setOpen, data }) {
  const handleClose = () => setOpen(false);
  const [response, setResponse] = React.useState([]);
  const claim_id = data?.stockists_master_id;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
    try {
      const jsonString = data.cn_response
        .replace(/False/g, "false")
        .replace(/True/g, "true")
        .replace(/'/g, '"')
        .replace(/doesn"t/g, "doesn't");

      const responseObject = JSON.parse(jsonString);
      setResponse(responseObject);
    } catch (error) {
      console.error("Failed to parse cn_response:", error);
      setResponse([]);
    }
  }, [data]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isSmallScreen ? "90%" : "50%",
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 6,
          borderRadius: 2,
          overflowY: "auto",
          p: 3,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Credit Note Response - {String(claim_id).padStart(10, "0")}
        </Typography>
        <Stack spacing={2}>
          {[...response].reverse().map((item, idx) => (
            <Paper
              key={idx}
              elevation={1}
              sx={{ p: 2, borderRadius: 2, bgcolor: "grey.50" }}
            >
              <Typography variant="subtitle2" color="text.secondary">
                #{response.length - idx}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack spacing={1}>
                <Typography variant="body2">
                  <b>Success:</b> {item.success.toString()}
                </Typography>
                <Typography variant="body2">
                  <b>Message:</b> {item.message}
                </Typography>
                {item.order_type && (
                  <Typography variant="body2">
                    <b>Order Type:</b> {item.order_type}
                  </Typography>
                )}
              </Stack>
            </Paper>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
